var ErrorModel = /** @class */ (function () {
    function ErrorModel(source) {
        var _this = this;
        Object.keys(source).forEach(function (x) {
            _this[x] = source[x];
        }, this);
    }
    return ErrorModel;
}());
export { ErrorModel };
//# sourceMappingURL=ErrorModel.js.map